module.exports = __webpack_public_path__ + "static/img/beian-icon.23ce7ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/beian-icon.png
// module id = i9hq
// module chunks = 0